import {
    GET_CONFIG_FORM92,
    GET_CONSULTA_CASOS,
    CLEAN_CASOS,
    SET_QUERY_STATE
} from '../types';


export default function areaBusquedaCasosInformesReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM92:
            return { ...state, cfg_form92:action.payload }
        case GET_CONSULTA_CASOS:
            return { ...state, consultaCasos:action.payload }
        case CLEAN_CASOS:
            return { ...state, consultaCasos:{} }
        case SET_QUERY_STATE:
            return { ...state, myQueryStateGlobal:action.payload }       
        default:
            return state
    }
}